import React, { useState } from 'react';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import './addnewoffice.scss';
import { ReactComponent as Office } from '../../images/office.svg';
import Modal from '../../components/Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import NotificationModal from '../../components/NotificationModal/NotificationModal';
import useFetch from '../../hooks/useFetch';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';

function AddNewOffice() {
  const [addNewModalOpen, setAddNewModalOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const { pathname } = useLocation();
  const isAssign = pathname === '/assign-office-to-team';
  const { data: companies, error, isLoading } = useFetch('/operations/companies/');
  const addNewOffice = (e) => {
    e.preventDefault();
    setAddNewModalOpen(false);
    setToastOpen(true);
    setTimeout(() => {
      setToastOpen(false);
    }, 500);
    //open toast
  };

  React.useEffect(() => {
    if (companies?.length === 0) {
      toast.warn('No companies found');
    }
  }, [companies]);

  React.useEffect(() => {
    if (error) {
      toast.error('Error fetching companies', {
        toastId: 'error-fetching-companies',
      });
    }
  }, [error]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      {!isAssign && (
        <>
          <Modal open={addNewModalOpen} style={{ maxWidth: '' }} onClose={() => setAddNewModalOpen(false)}>
            <div className="aomodal" style={{ height: 'unset' }}>
              <div className="modheader">
                <p
                  style={{
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    fontSize: '24px',
                    fontWeight: '700',
                  }}>
                  Add New Office
                </p>
                <CloseIcon
                  style={{ fill: 'white', cursor: 'pointer' }}
                  width="18px"
                  height="18px"
                  onClick={() => setAddNewModalOpen(false)}
                />
              </div>
              <form className="anoffice" onSubmit={addNewOffice}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '10px',
                  }}>
                  <div className="ethird">
                    <p>Broker Name</p>
                    <Input placeholder="Broker Name" name="name" required autoFocus />
                  </div>
                  <div style={{ width: '40%' }}>
                    <span>Telephone Number</span>
                    <Input required placeholder="Telephone Number" type="tel" />
                  </div>
                </div>
                <p>Broker Office Location</p>
                <div className="div">
                  <div>
                    <span>City</span>
                    <Input required placeholder="City" />
                  </div>
                  <div>
                    <span>Address</span>
                    <Input required placeholder="Address" />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '10px',
                    justifyContent: 'space-between',
                  }}>
                  <div className="ethird" style={{ width: '60%' }}>
                    <p>Broker Office Website Link</p>
                    <Input type="url" placeholder="Enter website address" />
                  </div>
                  <div>
                    <p>Office Size</p>
                    <select required>
                      <option value="SM">Small</option>
                      <option value="M">Medium</option>
                      <option value="L">Large</option>
                      <option value="XL">Extra Large</option>
                    </select>
                  </div>
                  <div>
                    <p>Office Location</p>
                    <select required>
                      <option>Northern CA</option>
                      <option>Southern CA</option>
                    </select>
                  </div>
                </div>
                <div className="evener">
                  <div>
                    <span>Broker Manager Name</span>
                    <Input required placeholder="Broker Manager Name" />
                  </div>
                  <div>
                    <span>Broker Manager Email</span>
                    <Input required placeholder="Broker Manager Email" type="email" />
                  </div>
                  <div>
                    <span>Broker Manager Number</span>
                    <Input required placeholder="Broker Manager Number" />
                  </div>
                </div>
                <Button
                  style={{
                    width: '100px',
                    fontSize: '16px',
                    padding: '10px',
                    color: 'white',
                    backgroundColor: 'var(--primary-color)',
                    display: 'block',
                    marginLeft: 'auto',
                  }}
                  text="Submit"
                  type="submit"
                />
              </form>
            </div>
          </Modal>
          <NotificationModal isOpen={toastOpen} message="New Office Added" />
        </>
      )}
      <div className="addnewoffice">
        <form className="modinputs" onSubmit={(e) => e.preventDefault()}>
          <Input placeholder="Enter State" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Input placeholder="Enter County" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Input placeholder="Enter Office Address" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Input placeholder="Enter Office Name" style={{ fontSize: '16px', padding: '10px 20px' }} />
          <Button
            style={{
              width: '100px',
              fontSize: '16px',
              padding: '10px',
              color: 'white',
              backgroundColor: 'var(--primary-color)',
              display: 'block',
            }}
            text="Filter"
          />
        </form>
        {/* {!isAssign && (
					<Button
						style={{
							width: '150px',
							fontSize: '16px',
							padding: '10px',
							color: 'white',
							backgroundColor: 'var(--primary-color)',
							display: 'block',
						}}
						text='Add New Office'
						onClick={() => setAddNewModalOpen(true)}
					/>
				)} */}
        <div className="offices">
          {companies && companies.map(({ id, name }) => <OfficeItem name={name} id={id} key={id} />)}
        </div>
      </div>
    </>
  );
}

export default AddNewOffice;

const OfficeItem = ({ name, id }) => {
  const navigate = useNavigate();

  return (
    <div className="office" onClick={() => navigate(`${id}`, { state: { name } })}>
      <Office />
      <p>{name}</p>
    </div>
  );
};
